import {ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, ViewRef} from '@angular/core';
import {ManageTaxStrategiesServices} from "../../tpiq-services/manage-tax-strategies.service";
import {SwitchBoard} from "../../services/SwitchBoard";
import {takeUntil} from "rxjs/operators";
import {Session} from "../../services/Session";
import {CommonModule} from "@angular/common";
import {TpiqSelectDropdownComponent} from "../../input-search/tpiq-select-dropdown/tpiq-select-dropdown.component";
import {FormsModule} from "@angular/forms";
import {windowScroll} from "../../services/window-scrolling.service";
import { NgMultiSelectDropDownModule} from "ng-multiselect-dropdown";

declare let _: any;

@Component({
  selector: 'app-client-labels-search',
  standalone: true,
  imports: [CommonModule, FormsModule, TpiqSelectDropdownComponent, NgMultiSelectDropDownModule],
  templateUrl: './client-labels-search.component.html',
  styleUrl: './client-labels-search.component.scss'
})
export class ClientLabelsSearchComponent implements OnInit, OnDestroy {
  org: any;
  searchModel: any;
  searchLabels: Array<any> = [];
  reveal: any = {
    search: false
  };
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  labelsList: Array<any> = [];
  user: string;
  labelsDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'label',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true,
  };
  statusTypes: Array<any> = [{name: 'Potential Client'}, {name: 'Client'}, {name: 'Former Client'}, {name: 'Closed - Lost'}, {name: 'Inactive'}, {name: 'All'}, {name: 'Custom'}];

  constructor(private switchBoard: SwitchBoard,
              private windowScroll: windowScroll,
              private changeDetectionRef: ChangeDetectorRef,
              private taxStrategyServices: ManageTaxStrategiesServices) {
    this.switchBoard.onSearchLabelDelete.pipe(takeUntil(this.destroy$)).subscribe(search => {
      if (search && search.searchItem && search.searchItem.key == 'status') {
        this.searchModel.status = '';
      } else if (search && search.searchItem && search.searchItem.key == 'selectedLabels') {
        this.searchModel.selectedLabels = [];
      }
      this.advanceLabelsSearch();
    });


  }

  ngOnInit(): void {
    this._init();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  _init() {
    this.org = Session.getOrg();
    this.user = Session.getUser().id;
    this.searchModel =  {
      selectedLabels: [],
      status: 'All'
    };
    this.getFirmLabelsData();
  }

  getFirmLabelsData() {
    this.taxStrategyServices.getLabelsDataForFirm(this.org, this.user)
      .subscribe(response => {
        this.labelsList = response || [];
        if (!(this.changeDetectionRef as ViewRef).destroyed) {
          this.changeDetectionRef.detectChanges();
        }
      }, error => {
        console.error('Failed to load labels:', error);
      });
  }

  toggle($event){
    this.reveal = {...this.reveal, search: true};
  }

  hideReveal(revealFlag, isResetLabels?){
    this.windowScroll.enable();
    this.reveal[revealFlag] = false;
    if (isResetLabels) {
      this.searchModel.selectedLabels = [];
    }
    if (!(this.changeDetectionRef as ViewRef).destroyed) {
      this.changeDetectionRef.detectChanges();
    }
  }

  removeSearchLabel(label, index) {
    this.searchLabels.splice(index, 1);
    this.searchModel[label.key] = '';
    if (label.dropdownKey) {
      this.searchModel[label.dropdownKey] = [];
    }
    if (label.selectedArrayKey) {
      this.searchModel[label.selectedArrayKey] = [];
    }
    let searchFilters = _.map(this.searchModel.selectedLabels, 'id');
    let searchObj = {};
    searchObj = {searchKey: 'labels', searchFilters};
    if (this.searchLabels.length == 0) {
      searchObj = {};
    }
    const data = {filters: this.searchLabels, searchObj};
    this.switchBoard.onClientLabelsAdvSearch.next(data);
  }

  advanceLabelsSearch(){
    const labels = this.getSelectedNames(this.searchModel.selectedLabels, 'label');
    const searchFilters = _.map(this.searchModel.selectedLabels, 'id');
    this.searchLabels = [
      {
        key: 'selectedLabels',
        value: labels,
        modelValue : this.searchModel.selectedLabels,
        displayName: 'Labels',
        dropdownKey: '',
        selectedArrayKey: 'selectedLabels'
      },
      {
        key: 'status',
        value: this.searchModel.status,
        displayName: 'Status',
        dropdownKey: '',
        selectedArrayKey: 'status'
      }
    ];
    this.searchLabels = this.searchLabels.filter(( obj ) => {
      return obj.value;
    });
    const obj: any = {searchKey: 'labels', searchFilters};
    const data = {filters: this.searchLabels, searchObj: this.searchModel, selectedValues: this.searchModel.selectedLabels};
    this.switchBoard.onClientLabelsAdvSearch.next(data);
    this.hideReveal('search');
  }

  getSelectedNames(obj, type) {
    let labels = [];
    _.forEach(obj, function (value) {
      labels.push(value[type]);
    });
    return labels.join(',');
  }

  onClientFilterSelect(label: any, check) {
    if (check) {
      this.searchModel.selectedLabels.push(label);
      this.searchModel.selectedLabels = _.uniqBy(this.searchModel.selectedLabels, 'id');
    } else {
      this.searchModel.selectedLabels = _.without(this.searchModel.selectedLabels, label.id);
    }
  }

  onAllClientsFilterSelect(labels: any, check) {
    if (check) {
      this.searchModel.selectedLabels = _.map(labels, 'id');
    } else {
      this.searchModel.selectedLabels = [];
    }
  }

  setStatus($event){
    this.searchModel.status = $event.name;
  }

}
